import { IoMdDownload } from "react-icons/io";
import { toast } from "react-toastify";
import TableComponent from "../../../Comman/TableComponent";
import Pagination from "../../../Comman/Pagination";
import { useEffect, useState } from "react";
import { ProjectService } from "../../../../services/ProjectService";
import { useParams } from "react-router-dom";
import { useSearch } from "../../../../context/SearchContext";
import DocumentTypeFilter from "../../../Comman/DocumentTypeFilter";
import { usePagination } from "../../../../hooks/usePagination";
import MobOldDocument from "./MobOldDocument";


export default function EmpOldDocument() {
  const { id } = useParams(); 
  const { debounceSearchTerm } = useSearch();
  const [documents, setDocuments] = useState([]);
  const [docType, setDocType] = useState('');
  const { currentPage, totalPages, goToPage, setTotalPages } = usePagination();

  const fixedDate = process.env.REACT_APP_FIXED_DATE;

  const handleDownloadClick = async (doc) => {
    try {
      const response = await ProjectService.viewDocumentById(doc.id);

      if (response && response.data && response.type) {
        const extensionMap = {
          "application/pdf": "pdf",
          "image/png": "png",
          "image/jpeg": "jpg",
          "image/jpg": "jpg",
          "image/webp": "webp",
          "application/zip": "zip",
          "application/x-zip-compressed": "zip",
          "application/msword": "doc",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document": "docx",
          "application/vnd.ms-excel": "xls",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "xlsx",
          "text/plain": "txt",
          "application/json": "json",
          "application/octet-stream": "bin",
        };

        const extension = extensionMap[response.type] || "file";
        const base64Data = response.data.split(",")[1];
        const byteCharacters = atob(base64Data);
        const byteNumbers = Array.from(byteCharacters, c => c.charCodeAt(0));
        const byteArray = new Uint8Array(byteNumbers);

        const blob = new Blob([byteArray], { type: response.type });
        const url = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = `${doc.documentName}.${extension}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        URL.revokeObjectURL(url);
      }
    } catch (error) {
      toast.error(error?.message || "Download failed");
    }
  };

  const columns = [
    {
      label: "Document Name",
      field: "documentName",
      headerClassName: "text-left pl-2 border-l border-t border-b border-[#d3cccc]",
      className: "text-[15px] text-left pl-2 border-l border-[#d3cccc]",
    },
    {
      label: "File Name",
      field: "fileName",
      headerClassName: "text-left pl-2 border-t border-b border-[#d3cccc]",
      className: "text-[15px] text-left pl-2 border-[#d3cccc]",
    },
    {
      label: "Doc Type",
      field: "documentType",
      headerClassName: "text-left pl-2 border-t border-b border-[#d3cccc]",
      className: "text-[15px] text-left pl-2 border-[#d3cccc] capitalize",
    },
    {
      label: "Date",
      field: "uploadDate",
      headerClassName: "text-left pl-2 border-t border-b border-[#d3cccc]",
      className: "text-[15px] text-left pl-2 border-[#d3cccc]",
    },
    {
      label: "Uploded By",
      field: "uploadBy",
      headerClassName: "text-left pl-2 border-t border-b border-[#d3cccc]",
      className: "text-[15px] text-left pl-2 border-[#d3cccc]",
    },
    {
      label: "Download",
      headerClassName: "border-t border-b border-r border-[#d3cccc] text-center",
      className: "border-[#d3cccc] border-r",
      render: (doc) => (
        <IoMdDownload
          className="text-blue-600 text-xl cursor-pointer mx-auto"
          onClick={() => handleDownloadClick(doc)}
        />
      ),
    },
  ];

  useEffect(() => {
    const fetchDocuments = async () => {
      try {
        const response = await ProjectService.getProjectDocuments(
          id,
          0,
          0,
          "MRR",
          currentPage,
          10,
          debounceSearchTerm,
          docType,
          fixedDate
        );

        if (response) {
          setDocuments(response.data);
          setTotalPages(response.pagination.totalPages);
        }
      } catch (error) {
        toast.error(error?.message);
      }
    };

    fetchDocuments();
  }, [debounceSearchTerm, id, currentPage, docType, fixedDate, setTotalPages]);

  return (
    <section className="p-4 sm:p-5">
      <div className="px-2 sm:px-6 py-2">
{/* Filter */}
<div className="flex justify-end items-center mb-3">
  <DocumentTypeFilter docType={docType} setDocType={setDocType} />
</div>

{/* ================= MOBILE ================= */}
<div className="md:hidden">
  <MobOldDocument
    documents={documents}
    onDownload={handleDownloadClick}
  />
</div>

{/* ================= DESKTOP ================= */}
<div className="hidden md:block w-full overflow-x-auto">
  <div className="min-w-[900px]">
    <TableComponent
      columns={columns}
      data={documents}
      headerBg="bg-[#f6f6f6]"
    />
  </div>
</div>


        <br />

        {documents.length > 0 && (
          <div className="flex justify-center sm:justify-end">
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              goToPage={goToPage}
            />
          </div>
        )}
      </div>
    </section>
  );
}
